import React from "react";
import SectionsConfigurator from "../SectionsConfigurator";

// Matches the Groundworks workflow's stepper order (StepperNavigation.tsx).
export const GROUNDWORKS_SECTIONS = [
  "Cut & Fill",
  "Foundations",
  "Drainage",
  "Plot Drives",
  "Plot Service",
  "Plot Paving",
  "Scaffold Platforms",
  "Garden",
  "Ret & Screen Walls",
  "Geowall & Tobermore Walls",
];

interface GroundworksTakeoffConfigProps {
  onChangeJobType: () => void;
}

const GroundworksTakeoffConfig: React.FC<GroundworksTakeoffConfigProps> = ({ onChangeJobType }) => (
  <SectionsConfigurator
    jobType="groundworks"
    jobTypeLabel="Groundworks"
    sections={GROUNDWORKS_SECTIONS}
    onChangeJobType={onChangeJobType}
  />
);

export default GroundworksTakeoffConfig;
